import { useCallback, useEffect, useState } from 'react';
import { readJsonPref, writeJsonPref } from '@utils/localJsonPref';

/** How the track draws the day's markers: one badge row, or one row per lane. */
export type ReplayMarkerView = 'badges' | 'lanes';

const KEY = 'dorca_replay_marker_view';

/** The viewer's last marker view, remembered across days and reloads; badges until they switch. The toggle is stable. */
export function useMarkerView(): [ReplayMarkerView, () => void] {
  const [view, setView] = useState<ReplayMarkerView>(() => (readJsonPref(KEY) === 'lanes' ? 'lanes' : 'badges'));
  useEffect(() => writeJsonPref(KEY, view), [view]);
  const toggle = useCallback(() => setView((current) => (current === 'badges' ? 'lanes' : 'badges')), []);
  return [view, toggle];
}
